/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './physio-order-item.reducer';

export const PhysioOrderItemDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const physioOrderItemEntity = useAppSelector(state => state.physioOrderItem.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="physioOrderItemDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.physioOrderItem.detail.title">PhysioOrderItem</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.physioOrderItem.id">Id</Translate>
            </span>
          </dt>
          <dd>{physioOrderItemEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.physioOrderItem.active">Active</Translate>
            </span>
          </dt>
          <dd>{physioOrderItemEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.physioOrderItem.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{physioOrderItemEntity.cursor}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.physioOrderItem.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{physioOrderItemEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.physioOrderItem.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{physioOrderItemEntity.microSec}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.physioOrderItem.order">Order</Translate>
          </dt>
          <dd>{physioOrderItemEntity.order ? physioOrderItemEntity.order.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/physio-order-item" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/physio-order-item/${physioOrderItemEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PhysioOrderItemDetail;
